import React, { useEffect } from 'react';
import { useShouldRemoveTaboolaAds } from 'lib/subscriptionUtils';

/**
 * TaboolaRecoReel component with subscription logic
 * @returns {React.ReactElement|null} TaboolaRecoReel component or null if hidden
 */
export function TaboolaRecoReel() {
  const shouldRemoveTaboolaAds = useShouldRemoveTaboolaAds();

  // the code in this useEffect was provided by taboola, see details in ticket:
  // https://nbcnewsdigital.atlassian.net/browse/BENTO-22253

  useEffect(() => {
    // eslint-disable-next-line no-underscore-dangle
    window._taboola = window._taboola || [];
    // eslint-disable-next-line no-underscore-dangle
    window._taboola.push({
      mode: 'reco-reel',
      container: 'taboola-mid-article-reco-reel',
      placement: 'Mid Article Reco Reel',
      target_type: 'mix',
    });
  }, []);

  // Do not render component if Taboola should be hidden for ad-free subscriber
  if (shouldRemoveTaboolaAds) {
    return null;
  }

  return (
    <div id="taboola-mid-article-reco-reel" data-testid="taboola-mid-article-reco-reel" />
  );
}
